(function () {
    'use strict';

    angular
        .module('AsyncPanel')
        .directive('panelContentTab', panelContentTab);

    // const template = ``;
    //const template = `<div class="async-panel-tab flex-style flex-column flex-nowrap"><div class="apt-menu-wrapper"><ul class="menu"><li ng-repeat="panelContent in vm.panelContents" ng-bind="panelContent.name" ng-click="vm.setActive(panelContent)" ng-class="{'active': vm.isActive(panelContent)}"></li></ul></div><div class="apt-content-wrapper flex-item-grow-1" style="min-height: 0;"><async-panel data="vm.data" options="vm.pageData.activeOption" refresh="vm.refreshAsyncPanel" ng-if="vm.pageData.activeOption" is-refreshing="vm.refreshing"></async-panel></div></div>`;

    function panelContentTab(lodash, CommonHelper) {
        return {
            restrict: 'E',
            controller: panelContentTabCtrl,
            controllerAs: 'vm',
            bindToController: true,
            scope: {
                panelContents: '=?',
                data: '=?',
                settings: '=?',
            },
            templateUrl: function (tElement, tAttrs) {
                // var templateName = lodash.get(tAttrs, 'template', '');
                if (lodash.has(tAttrs, 'templateFullPath')) {
                    return tAttrs.templateFullPath;
                }

                if (lodash.has(tAttrs, 'templateName')) {
                    return 'common/app/panel-content/' + tAttrs.templateName;
                } else {
                    return 'common/app/panel-content/panel-content-tab-horizontal';
                }
            }
        };
    }

    function panelContentTabCtrl($timeout, lodash, PanelContentTabService, $scope, PanelManager, $location) {
        var vm = this;
        var stopWatchingLocation = null;
        var field = '';
        var identifier = '';

        this.$onInit = function() {
            vm.pageData = {
                activeOption: null,
            };
            refreshTabsVisibility();
            // vm.visiblePanelContents = angular.copy(vm.panelContents);

            vm.settings = lodash.get(vm, 'settings', {});
            vm.settings.setActiveFromAction = setActiveFromAction;
            vm.settings.refreshTabsVisibility = refreshTabsVisibility;
            vm.settings.stepIsRefreshing = false;

            field = lodash.get(vm.settings, 'tab_identifier_key', 'panel_content_id');

            identifier = lodash.get(vm.settings, 'identifier', $scope.$id);
            PanelContentTabService.init(vm.settings);
            PanelContentTabService.sync(identifier, vm);
            PanelContentTabService.refreshModel(identifier);

            // vm.pageData.activeOption = vm.panelContents[0];
            // handleInitActive();

            vm.setActive = setActive;
            vm.isActive = isActive;
            vm.showButton = showButton;
            vm.isRefreshing = isRefreshing;
            vm.setActiveInit = setActiveInit;
            vm.isStepModelEmpty = isStepModelEmpty;

            $scope.$on('$destroy', function () {
                PanelContentTabService.destroy(identifier);
            });

            $scope.$on('$locationChangeSuccess', locationChangeSuccess);
            stopWatchingLocation = $scope.$on("$locationChangeStart", locationChangeStart);
        }

        function locationChangeSuccess(evt, newpath, oldpath) {
            var path_info = newpath.split('?');
            if (path_info.length > 1) {
                var params = path_info[1].split('&').reduce(function (result, _param) {
                    var split_param = _param.split('=');
                    result[split_param[0]] = split_param[1];
                    return result;
                }, {});

                var step = lodash.get(params, 'step');
                var type = lodash.get(params, 'type');
                if (step) {

                    var panel_content = lodash.find(vm.visiblePanelContents, function (_p) {
                        return _p.name.toLowerCase() === step.toLowerCase();
                    });
                    if (panel_content && lodash.get(vm.pageData.activeOption, 'name') !== step) {
                        // if (panel_content && lodash.get(vm.pageData.activeOption, 'step', step) !== step) {
                        setActive(panel_content, type);
                    }
                }
            }
            if (typeof stopWatchingLocation !== typeof function () {
            }) {
                stopWatchingLocation = $scope.$on("$locationChangeStart", locationChangeStart);
            }
        }

        function locationChangeStart() {
            if (typeof stopWatchingLocation === typeof function () {
            }) {
                stopWatchingLocation();
            }
        }

        function setActive(panelContent, childKey) {
            var children = lodash.get(panelContent, 'children', []);
            var panel = panelContent;

            vm.settings.stepIsRefreshing = true;
            vm.pageData.activeOption = null;

            $location.search({});

            if (children.length > 0) {
                panel = children[0];

                if (childKey) {
                    panel = lodash.find(children, function (child) {
                        return child.key === childKey || child.name === childKey;
                    });
                }

                if (panel === undefined) {
                    return;
                }

                panel['siblings'] = children;
                panel['parent'] = panelContent;
                $location.search('type', panel.name);
            }

            $location.search('step', panelContent.name);

            $timeout(function () {
                vm.pageData.activeOption = panel;
                var event = lodash.get(vm.settings, 'async.event.change', null);
                vm.settings.stepIsRefreshing = false;
                if (event) {
                    $scope.$emit(event, {scope: vm, target: panel});
                }
            });
        }

        function setActiveFromAction(identifier) {
            var panelContent = lodash.find(vm.visiblePanelContents, {[field]: identifier});
            var parentKey = lodash.get(panelContent, 'parent_key', false);
            if (parentKey) {
                var parent = lodash.find(vm.visiblePanelContents, {key: parentKey});
                return setActive(parent, panelContent.key)
            }
            setActive(panelContent);
        }

        function isActive(panelContent) {
            var children = lodash.get(panelContent, 'children', false);
            var activePanelContentIdentifier = lodash.get(vm.pageData.activeOption, field, false);
            return children
                ? lodash.some(children, function (child) {
                    return child[field] === activePanelContentIdentifier
                })
                : panelContent[field] === activePanelContentIdentifier;
        }

        function setActiveInit() {
            // var activePanels = lodash.filter(vm.data)
            // console.log('setActiveInit', vm.stepModel);
            var activeVisiblePanelContents = angular.copy(vm.visiblePanelContents);
            if (!isStepModelEmpty()) {
                var activePanelsRef = lodash.filter(lodash.values(vm.stepModel), {active: true});
                activeVisiblePanelContents = activePanelsRef.reduce(function (result, ref) {
                    var _p = lodash.find(vm.visiblePanelContents, {step: ref.identifier});
                    if (!!_p) {
                        result.push(_p);
                    }
                    return result;
                }, []);
            }

            var stepPanelContent = null;
            var typePanelContent = null;
            var activePanelContent = null;

            var searchData = $location.search();
            var step = lodash.get(searchData, 'step', null);
            var type = lodash.get(searchData, 'type', null);

            if (!!step) {
                stepPanelContent = lodash.find(activeVisiblePanelContents, function (panel_content) {
                    return panel_content.name.toLowerCase() === step.toLowerCase();
                });

                activePanelContent = stepPanelContent;

                var children = lodash.get(activePanelContent, 'children', false);
                var isChild = lodash.get(activePanelContent, 'child', false);

                if (children && children.length > 0) {
                    // !!type
                    //     ? typePanelContent = lodash.find(activeVisiblePanelContents, function (panel_content) {
                    //         return panel_content.name.toLowerCase() === type.toLowerCase();
                    //     })
                    //     : typePanelContent = children[0];

                    if (!!type) {
                        typePanelContent = lodash.find(activeVisiblePanelContents, function (panel_content) {
                            return panel_content.name.toLowerCase() === type.toLowerCase();
                        })
                    }

                    if (!typePanelContent) {
                        typePanelContent = children[0];
                    }

                    typePanelContent['siblings'] = stepPanelContent.children;
                    typePanelContent['parent'] = stepPanelContent;
                    activePanelContent = typePanelContent;

                    $location.search('type', lodash.get(typePanelContent, 'name'));
                }

                if (isChild) {
                    var parentKey = lodash.get(activePanelContent, 'parent_key');
                    var parent = lodash.find(vm.visiblePanelContents, {key: parentKey});
                    $location.search('step', parent.name);
                    $location.search('type', lodash.get(stepPanelContent, 'name'));
                }

                if (stepPanelContent) {
                    vm.pageData.activeOption = activePanelContent;
                    return;
                }
            }

            $location.search('step', null);

            var defaultStep = lodash.get(vm.settings, 'defaultStep', null);
            if (defaultStep) {
                stepPanelContent = lodash.find(activeVisiblePanelContents, function (panel_content) {
                    return panel_content.name.toLowerCase() === defaultStep.toLowerCase();
                });
                vm.pageData.activeOption = stepPanelContent;
            } else {
                vm.pageData.activeOption = activeVisiblePanelContents[0];
            }
        }

        function isStepModelEmpty() {
            return lodash.isEmpty(vm.stepModel);
        }

        function showButton(button) {
            // var selected_panel_content_id = lodash.get(vm.pageData, 'activeOption.panel_content_id', false);

            // if (!selected_panel_content_id) return false;

            // var buttons_data = lodash.get(vm.settings, 'buttonShowConfig.' + selected_panel_content_id, {});

            // return lodash.get(buttons_data, button.name, false);

            var visible_buttons = lodash.get(vm.pageData.activePanelState, 'state.structure.options.button_visibility', []);
            return !!lodash.get(visible_buttons, button.name, false);
        }

        function refreshTabsVisibility() {
            var panelContents = angular.copy(vm.panelContents);
            var parents = [];

            if (lodash.has(vm.settings, 'tab_visibility_rules')) {
                panelContents = panelContents.filter(function (panelContent, index) {
                    if (isVisible(panelContent)) {
                        if (lodash.has(panelContent, 'children')) parents.push(panelContent.key);
                        return true;
                    }
                });
            }

            vm.groupedTabs = lodash.groupBy(panelContents, function (panelContent) {
                return lodash.has(panelContent, 'child');
            });

            if (parents.length > 0) {
                parents.forEach(function (parentKey) {
                    var parentIndex = lodash.findIndex(panelContents, {key: parentKey});
                    var parent = panelContents[parentIndex];
                    panelContents[parentIndex]['children'] = vm.groupedTabs[true].filter(function (childPanel) {
                        return childPanel['parent_key'] === parent.key;
                    });
                });
            }
            vm.visiblePanelContents = panelContents;
            vm.visibleMenuTabs = vm.groupedTabs[false];
        }

        function isVisible(panelContent) {
            var rule = lodash.get(vm.settings, 'tab_visibility_rules.' + panelContent.key, false);
            if (rule && Array.isArray(rule)) {
                return lodash.some(rule, function (_rule) {
                    return lodash.get(vm.data, _rule, false);
                })
            }

            return lodash.get(vm.data, rule, false);
        }

        function isRefreshing() {
            return ((typeof vm.refreshing === typeof function () {
            }) ? vm.refreshing() : false) || vm.settings.stepIsRefreshing;
        }
    }
})();
